import React from 'react';

const year = new Date().getFullYear();

const Footer = props => (
  <footer>
    <section className="bg-dark">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-6 mb-5">
            <span>
              <img src="/images/logo/vkri-logo.svg" alt="Vespa" style={{ width: '100px' }} />
            </span>
            {'  '}
            <a href="/crovespa">
              <img src="/images/logo/crovespa-white-300px.png" alt="Crovespa 2014." style={{ width: '100px' }} />
            </a>
          </div>

          <div className="col-lg-2 col-md-6 mb-5 ml-auto">
            <h4 className="text-white">Social</h4>
            <div className="u-h-4 u-w-50 bg-red rounded mt-3 u-mb-40" />
            <ul className="list-inline social social-rounded mt-4">
              <li className="list-inline-item">
                <a href="https://www.facebook.com/vespaklubrijeka/" rel="noopener noreferrer" target="_blank">
                  <i className="fa fa-facebook" />
                </a>
              </li>
              <li className="list-inline-item">
                <a href="https://twitter.com/vespaklubrijeka" rel="noopener noreferrer" target="_blank">
                  <i className="fa fa-twitter" />
                </a>
              </li>
              <li className="list-inline-item">
                <a href="https://www.instagram.com/vespaklubrijeka/" rel="noopener noreferrer" target="_blank">
                  <i className="fa fa-instagram" />
                </a>
              </li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-6 mb-5 ml-auto">
            <h4 className="text-white">Sponzori</h4>
            <div className="u-h-4 u-w-50 bg-red rounded mt-3 u-mb-40" />
            <ul className="list-unstyled u-lh-2">
              <li className="mb-3">
                <a href="/">
                  <img src="/images/sponsors/170g_eng-hr.png" alt="TZ Opatija" />
                </a>
              </li>
              {/* <li className="mb-3">
                <a href="">Link dva</a>
              </li> */}
            </ul>
          </div>

          <div className="col-lg-3 col-md-6 mb-5 ml-auto">
            <h4 className="text-white">{props.footer.title}</h4>
            <div className="u-h-4 u-w-50 bg-red rounded mt-3 u-mb-40" />
            <ul className="list-unstyled">
              {/* <li className="mb-3">
                <span className="icon icon-Phone2 text-red mr-2" /> +123456789
              </li> */}
              <li className="mb-3">
                <span className="icon icon-Mail text-red mr-2" />{' '}
                <a href={`mailto:${props.footer.email}`}>{props.footer.email}</a>
              </li>
              <li className="mb-3">
                <span className="icon icon-Pointer text-red mr-2" /> {props.footer.street}
              </li>
              <li className="mb-3">
                <span className="icon icon-Pointer text-red mr-2" /> {props.footer.city}, {props.footer.country}
              </li>
            </ul>
          </div>
        </div>
        <div className="mb-0">
          Copyright &copy; {year} • Site by{' '}
          <a className="text-red" href="http://www.igorpavic.com" rel="noopener noreferrer" target="_blank">
            Igorpavic.com
          </a>
        </div>
      </div>
    </section>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js